import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cloneDeep from 'lodash/cloneDeep';
import orderBy from 'lodash/orderBy';
import { LinkContainer } from 'react-router-bootstrap';

import { OverlayTrigger, Tooltip, Button, DropdownButton, MenuItem, Label } from 'react-bootstrap';


import * as Table from 'reactabular-table';
import * as search from 'searchtabular';
import * as sort from 'sortabular';
import * as resolve from 'table-resolver';


import {
  Paginator, PrimaryControls, paginate
} from '../tableHelpers';


import _ from 'underscore'

//require('react-pagify/style.css')


var MobileDetect = require('mobile-detect');

import * as FichesActions from 'redux/modules/fiches';
import { resetFilter } from 'redux/modules/supervision';

import { push } from 'react-router-redux'

import * as ProductActions from 'redux/modules/products';
import { routeActions } from 'react-router-redux';

import { bindActionCreators } from 'redux';

import { translate } from 'react-i18next';

@translate(['common'])
@connect(
  state => ({
    user: state.auth.user,
    lastActivityOptions: state.fiches.lastActivityOptions
  }),
  dispatch => bindActionCreators({ ...routeActions, ...FichesActions, ...ProductActions, resetFilter }, dispatch)
)

export default class LastActivityTable extends React.Component {

  constructor(props) {

    super(props);

    var rows = this.props.data ? this.props.data : [];


    this.state = {
      isPhone: false,
      rows,
      searchColumn: 'all',
      query: {},
      sortingColumns: props.lastActivityOptions[props.type].sortingColumns,
      columns: this.getColumns(),
      pagination: {
        page: 1,
        perPage: 5
      }
    };


    this.onRow = this.onRow.bind(this);
    this.onRowSelected = this.onRowSelected.bind(this);
    this.onColumnChange = this.onColumnChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onPerPage = this.onPerPage.bind(this);
    this.onToggleColumn = this.onToggleColumn.bind(this);

    this.updateDimensions = this.updateDimensions.bind(this);
    this.getColumns = this.getColumns.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({ rows: this.props.data })
    }
  }

  componentDidMount() {

    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));

  }


  updateDimensions() {
    var md = new MobileDetect(window.navigator.userAgent);
    if (md.tablet() || md.phone()) {
      this.setState({ isPhone: true, columns: this.getColumns() })
    } else {
      this.setState({ isPhone: false, columns: this.getColumns() })
    }
  }



  getColumns() {

    var self = this;

    const {t} = self.props

    const sortable = sort.sort({
      getSortingColumns: () => this.state.sortingColumns || [],
      onSort: selectedColumn => {

        this.setState({
          sortingColumns: sort.byColumns({
            sortingColumns: this.state.sortingColumns,
            selectedColumn
          })
        });

        this.props.setLastActivityOptions(this.props.type, true, { sortingColumns: sort.byColumns({ sortingColumns: this.state.sortingColumns, selectedColumn }) })

      }
    });

    const sortableHeader = sortHeader(sortable, () => this.state.sortingColumns);



    var columns = [

      {
        //property: 'start_date',
        header: {
          label: t('main.info'),
          props: {
            className: "col col-md-1"
          }
        },

        cell: {
          formatters: [(value, { rowData }) => (

            <div style={{ display: 'inline-block', marginLeft: '2px' }}>
              <OverlayTrigger placement="top" overlay={<Tooltip>
                <div>

                  <div>{t('main.address')}Adresse : {rowData.Adresse} </div>

                  <div>{t('main.start')} : {new Date(rowData.start_date).toLocaleString()}</div>
                  <div>{t('main.end')} : {rowData.end_date ? new Date(rowData.end_date).toLocaleString() : t('main.in_progress')}</div>

                </div>

              </Tooltip>}>

                <Label bsStyle="danger">Info {/*!rowData.end_date ? '(Défaut en cours)' : ''*/}</Label>

              </OverlayTrigger>
            </div>



          )]
        },

        visible: true
      },


      {
        property: 'Numero_Client',
        header: {
          label: t("main.num_client"),
          formatters: [(v, extra) => sortableHeader(v, extra)],
          props: {
            className: "",
            style: { width: '100px' }
          }
        },
        visible: true
      },


      {

        header: {
          label:  t("main.actions"),

          props: {
            className: "",
            style: { width: '120px' }
          }
        },

        cell: {
          formatters: [(value, { rowData }) => {

            var supPath;

            var user = self.props.user;
            var params = self.props.params;

            if (user.role == 'admin') {
              supPath = '/' + params.role + '/supervision/' + params.id + '/?id=' + rowData.identification_ID + '&pid=' + rowData.p_id
            } else if (user.role.indexOf('client') > -1 || user.role == 'demo') {
              supPath = '/client/supervision/?id=' + rowData.identification_ID + '&pid=' + rowData.p_id
            } else {
              supPath = '/user/supervision/?id=' + rowData.identification_ID + '&pid=' + rowData.p_id
            }

            var editProductPath;
            if (user.role == 'admin') {
              editProductPath = '/' + params.role + '/' + params.id + '/product/' + rowData.p_id + '/edit'
            } else if (user.role.indexOf('client') > -1 || user.role == 'demo') {
              editProductPath = '/client/product/' + rowData.p_id + '/edit'
            } else {
              editProductPath = '/user/product/' + rowData.p_id + '/edit'
            }


            if (this.state.isPhone) {

              var menu =

                <DropdownButton
                  title={'Actions'}
                  key={'12'}
                >
                  <MenuItem eventKey="2">
                    <LinkContainer to={editProductPath}><span>{ t("main.edit_sheet") }</span></LinkContainer>
                  </MenuItem>
                  <MenuItem eventKey="2">
                    <LinkContainer to={editProductPath + '?dispo=1'}><span>{ t("main.bilan") }</span></LinkContainer>
                  </MenuItem>
                  <MenuItem eventKey="3">
                    <LinkContainer to={editProductPath + '?traffic=1'}><span>{ t("main.disponibility") }</span></LinkContainer>
                  </MenuItem>

                  <MenuItem eventKey="4">
                    <LinkContainer to={supPath}><span>{ t("main.supervision") }</span></LinkContainer>
                  </MenuItem>

                </DropdownButton>


            } else {





              var supBtn = (
                <button className={"btn btn-sm btn-" + self.props.style} onClick={() => {
                  self.props.resetFilter()

                  self.props.push(supPath)
                }}>
                  <i className="fa fa-eye" />
                </button>)
              /*
              var supBtn =
                  <LinkContainer to={supPath}>
                  <button className={"btn btn-sm btn-" + self.props.style} >
                    <i className="fa fa-eye" />
                  </button>
                </LinkContainer>*/

              const tooltip2 = (
                <Tooltip id="tooltip">
                  <strong>{ t("main.supervision_entries") }</strong>
                </Tooltip>
              );

              const tooltipEdit = (
                <Tooltip id="tooltip">
                  <strong>{ t("main.edit_sheet") }</strong>
                </Tooltip>
              );


              const tooltip3 = (
                <Tooltip id="tooltip">
                  <strong>{ t("main.bilan") }</strong>
                </Tooltip>
              );


              const tooltip6 = (
                <Tooltip id="tooltip">
                  <strong>{ t("main.disponibility") }</strong>
                </Tooltip>
              );



              var menu = (
                <div style={{ width: '116px', margin: '0' }}>

                  <div style={{ display: 'inline-block', marginLeft: '2px' }}>
                    <OverlayTrigger placement="top" overlay={tooltipEdit}>
                      <LinkContainer to={editProductPath}>
                        <button className={"btn btn-sm btn-" + self.props.style} >
                          <i className="fa fa-pencil" />
                        </button>
                      </LinkContainer>
                    </OverlayTrigger>
                  </div>

                  &nbsp;

                  <OverlayTrigger placement="top" overlay={tooltip3}>
                    <Button bsStyle='warning' bsSize="sm" disabled={rowData.identification_type == 'EM'} onClick={() => {
                      self.props.expandTabs(2000, true)
                      self.props.expandBasicTabs(2000, false)
                      self.props.push(editProductPath)
                    }}>
                      <i className="fa fa-line-chart" />

                    </Button>
                  </OverlayTrigger>

                  {/*
                  <div style={{ display: 'inline-block', marginLeft: '5px' }}>
                    <OverlayTrigger placement="top" overlay={tooltip3}>
                      <LinkContainer to={editProductPath + '?traffic=1'}>
                        <button className='btn btn-sm btn-warning' disabled={rowData.identification_type == 'EM'}>
                          <i className="fa fa-bar-chart" />
                        </button>
                      </LinkContainer>
                    </OverlayTrigger>
                  </div>

                  <div style={{ display: 'inline-block', marginLeft: '5px' }}>
                    <OverlayTrigger placement="top" overlay={tooltip6}>
                      <LinkContainer to={editProductPath + '?dispo=1'}>
                        <button className='btn btn-sm btn-warning'>
                          <i className="fa fa-line-chart" />
                        </button>

                      </LinkContainer>
                    </OverlayTrigger>
                  </div>

                  */}

                  <div style={{ display: 'inline-block', marginLeft: '5px' }}>
                    <OverlayTrigger placement="top" overlay={tooltip2}>
                      {supBtn}
                    </OverlayTrigger>
                  </div>

                </div>
              );

            }

            return menu

          }]
        },
        width: 10,
        visible: true
      }








    ]


    return columns;

  }



  render() {

    const {
      rows, searchColumn
    } = this.state;

    var columns = this.getColumns()

    let { pagination, sortingColumns, query } = this.props.lastActivityOptions[this.props.type]

    const cols = columns.filter(column => column.visible);
    const paginated = compose(
      paginate(pagination),
      sort.sorter({ columns: cols, sortingColumns, sort: orderBy }),
      search.highlighter({ columns: cols, matches: search.matches, query }),
      search.multipleColumns({ columns: cols, query }),
      resolve.resolve({
        columns: cols,
        method: ({ rowData, column }) => resolve.byFunction('cell.resolve')({
          rowData: resolve.nested({ rowData, column }),
          column
        })
      })
    )(rows);




    return (
      <div>
        {/*<VisibilityToggles
          columns={columns}
          onToggleColumn={this.onToggleColumn}
        />*/}


        {/*
        <PrimaryControls
          className="controls"
          perPage={pagination.perPage}
          column={searchColumn}
          query={query}
          columns={cols}
          rows={rows}
          onPerPage={this.onPerPage}
          onColumnChange={this.onColumnChange}
          onSearch={this.onSearch}
        />*/}



        {paginated.rows.length > 0 &&
          <div className="table-responsive" style={{ maxHeight: '350px' }}>
            <Table.Provider
              className="table table-striped"
              columns={cols}
              style={{ overflowX: 'auto' }}
            >
              <Table.Header>
                <search.Columns query={query} columns={cols} onChange={this.onSearch} />
              </Table.Header>

              <Table.Body onRow={this.onRow} rows={paginated.rows} rowKey="id" />

            </Table.Provider>

          </div>

        }

        {paginated.amount > 0 &&

          <div className="controls" style={{marginBottom:'0px'}}>
            <Paginator
              pagination={pagination}
              pages={paginated.amount}
              onSelect={this.onSelect}
              prevText={'<'}
              nextText={'>'}
            />
          </div>
        
        
        }

       
      </div>
    );
  }
  onRow(row, { rowIndex }) {
    return {
      onClick: () => this.onRowSelected(row)
    };
  }
  onRowSelected(row) {

  }
  onColumnChange(searchColumn) {
    this.setState({
      searchColumn
    });
  }
  onSearch(query) {


    this.setState({
      query
    });

    this.props.setLastActivityOptions(this.props.type, true, { query })
  }
  onSelect(page) {
    const pages = Math.ceil(
      this.state.rows.length / this.state.pagination.perPage
    );

    var pagination = {
      ...this.state.pagination,
      page: Math.min(Math.max(page, 1), pages)
    }

    this.setState({
      pagination
    });

    this.props.setLastActivityOptions(this.props.type, true, { pagination })
  }
  onPerPage(value) {


    var pagination = {
      ...this.state.pagination,
      perPage: parseInt(value, 10)
    }


    this.setState({
      pagination
    });


    this.props.setLastActivityOptions(this.props.type, true, { pagination })
  }

  onToggleColumn(columnIndex) {
    const columns = cloneDeep(this.state.columns);
    const column = columns[columnIndex];
    column.visible = !column.visible;
    const query = cloneDeep(this.state.query);
    delete query[column.property];
    this.setState({ columns, query });
  }
}

const CustomFooter = ({ columns, rows }) => {
  return (
    <tfoot>
      <tr>
        {columns.map((column, i) =>
          <td key={`footer-${i}`}>{column.footer ? column.footer(rows) : null}</td>
        )}
      </tr>
    </tfoot>
  );
}

function sortHeader(sortable, getSortingColumns) {
  return (value, { columnIndex }) => {
    const sortingColumns = getSortingColumns() || [];

    return (
      <div style={{ display: 'inline' }}>
        <span className="value">{value}</span>
        {React.createElement(
          'span',
          sortable(
            value,
            {
              columnIndex
            },
            {
              style: { float: 'right' }
            }
          )
        )}
        {sortingColumns[columnIndex] &&
          <span className="sort-order" style={{ marginLeft: '0.5em', float: 'right' }}>
            {sortingColumns[columnIndex].position + 1}
          </span>
        }
      </div>
    );
  };
}